import React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import { get } from 'lodash';

const inputComponent: React.FC<any> = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const SelectControl: React.FC<any> = ({
  children,
  innerProps,
  innerRef,
  selectProps: { classes, TextFieldProps, margin, noAdornment, isDisabled },
}) => (
  <TextField
    margin={margin || 'normal'}
    fullWidth
    disabled={isDisabled}
    {...TextFieldProps}
    InputProps={{
      startAdornment: noAdornment ? null : (
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      ),
      inputComponent,
      inputProps: {
        className: classes.input,
        ref: innerRef,
        children,
        ...innerProps,
      },
      ...get(TextFieldProps, 'InputProps'),
    }}
  />
);

export default SelectControl;
